export {BatchAdministratorPage} from './batch-administrator-page';
